import api from "../../../api";

export const requestGetTransaction = (id) => api.get(`/admin/transactions/${id}`);
